import { render, staticRenderFns } from "./TradeDealCapture.vue?vue&type=template&id=34f6bb3a&scoped=true"
import script from "./TradeDealCapture.vue?vue&type=script&lang=js"
export * from "./TradeDealCapture.vue?vue&type=script&lang=js"
import "./TradeDealCapture.vue?vue&type=style&index=0&id=34f6bb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f6bb3a",
  null
  
)

export default component.exports